import {
  Component, EventEmitter, Inject, Output,
} from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-worker-dashboard-form',
  templateUrl: './worker-dashboard-form.component.html',
})
export class WorkerDashboardFormComponent {
  form: FormGroup;

  @Output() dataChange = new EventEmitter<{ title?: string; description?: string }>();

  constructor(
    private fb: FormBuilder,
    @Inject('formData') public data: { title?: string; description?: string } = {},
  ) {
    this.form = this.fb.group({
      title: [data.title || ''],
      description: [data.description || ''],
    });

    this.form.valueChanges.subscribe((value) => {
      this.dataChange.emit(value);
    });
  }
}
